import { tv } from 'tailwind-variants';

export const defaultVariants = tv({
  slots: {
    base: ['w-full', 'gap-[40px]'],
    tabList: ['flex'],
    tab: [],
    panelWrapper: ['flex-1 min-w-0'],
    panel: ['w-full h-full'],
    imageContainer: ['w-full h-full'],
    imageWrapper: ['relative', 'flex flex-col-reverse ml:block'],
    image: [
      'mx-auto',
      'max-w-[300px] max-h-[250px] ml:max-w-none ml:max-h-none',
      'w-full h-full object-cover block',
    ],
    caption: [
      'ml:absolute ml:left-0 ml:right-0 ml:bottom-0',
      'ml:bg-black/70 ml:text-white',
      'font-srpsans text-[14px] leading-[20px]',
      'pb-5 ml:pb-0 ml:p-2.5',
      'ml:[&_p]:text-white! ml:text-center',
    ],
    rteContainer: ['[&_img]:rounded-none', '[&_img]:mt-0'],
  },
  variants: {
    orientation: {
      vertical: {
        tabList: ['flex-col gap-2.5'],
      },
      horizontal: {
        tabList: ['items-stretch justify-center', 'gap-[20px]'],
      },
    },
    phase: {
      in: {
        panelWrapper: ['animate-[tabFadeIn_0.15s_ease-in-out]'],
      },
      out: {
        panelWrapper: ['animate-[tabFadeOut_0.15s_ease-in-out_forwards]'],
      },
    },
  },
  defaultVariants: {
    orientation: 'vertical',
    phase: 'in',
  },
});

export const tabButtonVariants = tv({
  slots: {
    item: [],
    button: [
      'w-full',
      'flex items-center justify-center gap-1',
      'cursor-pointer',
      'hover:text-call-out',
      'border hover:border-call-out',
    ],
    tabIcon: ['w-full max-h-[95px]'],
    chevron: ['fa-solid fa-chevron-down', 'text-2xl absolute bottom-2.5 left-1/2 -translate-x-1/2'],
  },
  variants: {
    orientation: {
      vertical: {
        button: ['text-xl leading-[20.8px]', 'font-bold', 'py-5', 'rounded-[2.5px]'],
        chevron: ['hidden!'],
      },
      horizontal: {
        button: [
          'group',
          'relative',
          'flex items-center flex-col',
          'w-[155px] h-full',
          'rounded-sm',
          'py-2 px-4',
          'text-call-out font-extrabold',
          '[&_span]:pt-5 [&_span]:pb-8',
          'hover:scale-105',
        ],
        chevron: [
          'opacity-0',
          'group-hover:opacity-100',
          'transition-opacity duration-300 ease-in-out',
        ],
      },
    },
    // Border colour must be explicit in both states: the base `border` utility sets no colour, so it
    // would otherwise fall back to currentColor and pick up text-call-out on inactive tabs.
    isActive: {
      true: {
        button: ['border-call-out', 'text-call-out'],
      },
      false: {
        button: ['border-black/20'],
      },
    },
    hasIcon: {
      true: {
        button: ['justify-start', 'py-2', 'text-base font-bold text-call-out text-left'],
      },
    },
  },
  defaultVariants: {
    isActive: false,
    orientation: 'vertical',
  },
});

export const accordionVariants = tv({
  slots: {
    list: ['w-full', 'flex flex-col gap-2.5', 'm-0 mx-auto p-0', 'list-none'],
    itemWrapper: ['w-full', 'overflow-hidden'],
    contentWrapper: ['grid', 'transition-[grid-template-rows] duration-200 ease-linear'],
    contentInner: ['overflow-hidden min-h-0', 'transition-[visibility] duration-0'],
    panelWrapper: ['py-5'],
    tabIcon: ['shrink-0', 'size-[70px] object-contain', 'mx-2'],
    tabTitle: [],
  },
  variants: {
    hasIcon: {
      true: {
        tabTitle: ['flex-1 min-w-0 text-left pr-5'],
        panelWrapper: ['pt-6 pb-2'],
      },
    },
    isOpen: {
      true: {
        contentWrapper: ['grid-rows-[1fr]'],
        contentInner: ['visible delay-0'],
      },
      false: {
        contentWrapper: ['grid-rows-[0fr]'],
        contentInner: ['invisible delay-300'],
      },
    },
  },
  defaultVariants: {
    hasIcon: false,
    isOpen: false,
  },
});
